import * as React from 'react'
import { cn } from '@/lib/utils'

export interface EyebrowProps extends React.HTMLAttributes<HTMLDivElement> {
  dot?: boolean
}

export const Eyebrow = React.forwardRef<HTMLDivElement, EyebrowProps>(
  ({ className, dot = false, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'inline-flex w-fit items-center gap-2 rounded-full bg-[#F1F5F9] px-4 py-1.5 text-[13px] font-semibold text-[#475569]',
        className,
      )}
      {...props}
    >
      {dot && (
        <span className="h-1.5 w-1.5 rounded-full bg-green-500 animate-pulse" aria-hidden />
      )}
      <span>{children}</span>
    </div>
  ),
)
Eyebrow.displayName = 'Eyebrow'
